import React from 'react';
import Menu from "../menu_components/Menu";

export default function MenuPage() {
    return (
        <div className = "MenuPage">
            <div className= "MenuPage-Landing">
                <h1 className = "MenuPage-Title">Menu</h1>
                <div className = "Overlay"/>
            </div>

            <Menu/>
        </div>
    )
}
